import { FC } from "react"
import { SchedulesDetail } from "../../../module/schedules/containers/detail"

export const SchedulesDetailPage: FC = () => <SchedulesDetail />
